import { getCastellerSearchText } from '../../../utils/castellerName';

const normalize = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

const levenshteinDistance = (a, b) => {
    if (a.length === 0) return b.length;
    if (b.length === 0) return a.length;

    const matrix = [];
    for (let i = 0; i <= b.length; i++) matrix[i] = [i];
    for (let j = 0; j <= a.length; j++) matrix[0][j] = j;

    for (let i = 1; i <= b.length; i++) {
        for (let j = 1; j <= a.length; j++) {
            matrix[i][j] = b.charAt(i - 1) === a.charAt(j - 1)
                ? matrix[i - 1][j - 1]
                : Math.min(matrix[i - 1][j - 1] + 1, matrix[i - 1][j] + 1, matrix[i][j - 1] + 1);
        }
    }
    return matrix[b.length][a.length];
};

export const searchMatches = (casteller, query, maxDistance = 2) => {
    if (query.length === 0) return true;
    const words = normalize(getCastellerSearchText(casteller)).split(/\s+/);
    const searchWords = normalize(query).split(/\s+/);
    let totalDistance = 0;

    for (const searchWord of searchWords) {
        let closestDistance = Infinity;
        for (const word of words) {
            const distance = levenshteinDistance(word.slice(0, Math.min(word.length, searchWord.length)), searchWord);
            closestDistance = Math.min(closestDistance, distance);
        }
        totalDistance += closestDistance;
    }
    return totalDistance <= maxDistance;
};

// Both the controller and its lists must rank matches with the same weights.
export const sortMatches = (casteller, query) => {
    const normalizedQuery = normalize(query);
    const score = field => {
        const value = normalize(field || '');
        if (value === '' || normalizedQuery === '') return 1000;
        if (value === normalizedQuery) return 1;
        if (value.startsWith(normalizedQuery) || normalizedQuery.startsWith(value)) return 2;
        if (value.includes(normalizedQuery) || normalizedQuery.includes(value)) return 3;
        return 1000;
    };
    return Math.min(score(casteller.mote) * 10, score(casteller.nom) * 100, score(casteller.cognom) * 1000);
};
